export default __webpack_public_path__ + "static/media/senti_dots.b3b33832.svg";